import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import React, { useEffect } from "react";

type CustomFormItemProps = {
  value?: Dayjs;
  onChange?: (value: Dayjs) => void;
};

/**
 * A component that renders a calendar.
 * @param value initialValue passed by parent Form.Item.
 * @param onChange a callback for Form.Item to read its child component's value.
 * @constructor
 */
export const StartDateSelect: React.FC<CustomFormItemProps> = ({
  value,
  onChange,
}) => {
  useEffect(() => {
    // Propagate the current set date to oChange so that it can be used by EndDatePicker.
    // Otherwise it might be undefined.
    onChange(value ? value : dayjs());
  }, []);

  return (
    <DatePicker
      onChange={(date, dateString) => {
        if (date !== null) {
          onChange(date);
        }
      }}
      value={value}
      defaultValue={dayjs()}
      picker={"date"}
      style={{ width: "100%" }}
      showTime={false}
      format={"DD.MM.YYYY"}
    />
  );
};
